module.exports = __webpack_public_path__ + "static/media/b.23eb1c47.jpg";